import React, { useMemo } from 'react';

const COLORS = [
  '#42C3BA', // teal
  '#3b82f6', // blue
  '#f59e0b', // amber
  '#ef4444', // red
  '#8b5cf6', // purple
  '#ec4899', // pink
  '#10b981', // green
  '#f97316', // orange
  '#06b6d4', // cyan
  '#94a3b8', // slate
];

export default function EstadisticasTipoChart({ stros }) {
  const chartData = useMemo(() => {
    if (!stros || stros.length === 0) return [];

    const counts = {};
    stros.forEach(s => {
      const type = s.tipoStro ? s.tipoStro.trim().toUpperCase() : 'SIN ESPECIFICAR';
      counts[type] = (counts[type] || 0) + 1;
    });

    const total = stros.length;

    return Object.entries(counts)
      .map(([name, count]) => ({
        name,
        count,
        percentage: ((count / total) * 100).toFixed(1),
      }))
      .sort((a, b) => b.count - a.count)
      .slice(0, 8); // Top 8 types
  }, [stros]);

  const maxCount = useMemo(() => {
    if (chartData.length === 0) return 1;
    return Math.max(...chartData.map(d => d.count));
  }, [chartData]);

  if (!stros || stros.length === 0) {
    return (
      <div className="est-card">
        <div className="est-card-header">
          <span className="est-card-title">
            <i className="bi bi-bar-chart-line-fill"></i>
            Distribución por Tipo de Siniestro
          </span>
        </div>
        <div className="est-empty">
          <i className="bi bi-inbox"></i>
          <p>No hay siniestros cargados</p>
        </div>
      </div>
    );
  }

  return (
    <div className="est-card">
      <div className="est-card-header">
        <span className="est-card-title">
          <i className="bi bi-bar-chart-line-fill"></i>
          Distribución por Tipo de Siniestro
        </span>
        <span className="est-card-badge">
          {chartData.length} tipos principales
        </span>
      </div>

      <div className="est-bars-list">
        {chartData.map((item, idx) => {
          const color = COLORS[idx % COLORS.length];
          const widthPercent = (item.count / maxCount) * 100;

          return (
            <div className="est-bar-row" key={item.name}>
              <span className="est-bar-label" title={item.name}>
                {item.name}
              </span>
              <div className="est-bar-bg">
                <div
                  className="est-bar-fill"
                  style={{
                    width: `${widthPercent}%`,
                    backgroundColor: color,
                  }}
                />
              </div>
              <span className="est-bar-count">
                {item.count} <span style={{ fontSize: '10px', color: '#94a3b8', fontWeight: 500 }}>({item.percentage}%)</span>
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
